<template>
  <div class="student">
    <el-card v-auth="'student_/student/classInfoPageList'">
      <el-row :gutter="20">
        <el-col :sm="12" :md="6" :lg="4">
          <el-input
            v-model="searchForm.name"
            placeholder="请输入学员"
            auto-complete="off"
            clearable
          ></el-input>
        </el-col>
        <el-col :sm="12" :md="6" :lg="4">
          <el-input
            v-model="searchForm.goodsName"
            placeholder="请输入报名商品"
            auto-complete="off"
            clearable
          ></el-input>
        </el-col>
        <!-- <el-col :sm="12" :md="6" :lg="4">
          <el-select
            multiple
            collapse-tags
            clearable
            v-model="searchForm.studentGroupIds"
            placeholder="请选择学员分组"
          >
            <el-option
              v-for="item in studentGroupLIst"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col> -->
        <!-- <el-col :sm="24" :md="12" :lg="7">
            <el-form-item label="手机号码" prop="account">
              <el-input v-model="searchForm.account" placeholder="请输入手机号码" auto-complete="off"></el-input>
            </el-form-item>
        </el-col>-->
        <el-col :sm="12" :md="6" :lg="4">
          <el-select
            v-model="searchForm.fromType"
            placeholder="请选择来源"
            clearable
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.key"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :sm="12" :md="6" :lg="4">
          <el-cascader
            v-if="roleName == '系统管理员'"
            style="width: 100%"
            clearable
            :show-all-levels="false"
            :props="campusTreeProps"
            placeholder="请选择所属校区"
            :options="campusList"
            @change="campusChange"
          ></el-cascader>
        </el-col>
        <el-col :sm="12" :md="6" :lg="6">
          <el-date-picker
            style="width: 100%"
            v-model="searchForm.createTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-col>
      </el-row>
      <el-row :span="24" style="margin-top: 20px">
        <el-col style="text-align: left" :span="24">
          <el-button
            v-auth="'student_/student/addStudent'"
            style="text-align: left"
            type="primary"
            @click="
              ;((addFormVisible = true), (addForm.campusId = '')),
                getRegionTree(),
                getCampusList()
            "
            icon="el-icon-plus"
            >添加学员</el-button
          >
          <el-button
            v-auth="'student_/student/exportExcel'"
            style="text-align: left"
            type="primary"
            @click="exportExcel"
            :loading="exportLoading"
            >导出学员</el-button
          >
          <el-button
            type="primary"
            @click=";(page.pageNumber = 1), pageList()"
            icon="el-icon-search"
            >查询</el-button
          >
          <!-- <a class="mainColor mr" @click="reset" icon="el-icon-refresh">重置</a> -->
          <!-- <el-button
                  style="background:rgb(24,200,168);border-color:rgb(24,200,168)"
                  type="primary"
                  @click="addFormVisible = true"
                  icon="el-icon-plus"
          >新增</el-button>-->
          <!-- <el-button style="float: right" type="primary" @click="goOpen" icon="el-icon-plus">批量开课</el-button> -->
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px">
      <el-table
        v-auth="'student_/student/classInfoPageList'"
        ref="multipleTable"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 0px; width: 100%"
        border
        @selection-change="selectionChange"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column
          prop="state"
          label="是否启用"
          width="180px"
          align="center"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.state"
              :active-value="1"
              :inactive-value="-1"
              @change="updateSwitching(scope.row)"
              class="switchStyle"
              active-text="开"
              inactive-text="关"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="150px"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          width="160px"
        ></el-table-column>
        <el-table-column
          prop="nickName"
          label="昵称"
          width="160px"
        ></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="120px">
          <template slot-scope="scope">
            <span class="mainColor">{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="goodsInfos" label="报名商品" minWidth="180px">
          <template slot-scope="row">
            <el-tooltip
              :open-delay="300"
              class="item"
              effect="dark"
              :content="v.name"
              v-for="(v, k) in row.row.goodsInfos"
              :key="k"
            >
              <div class="answer">
                {{ v.name || 'null' }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="fromType" label="来源" minWidth="180px">
          <template slot-scope="scope">
            <div v-if="scope.row.fromType == '代理'">代理</div>
            <div v-if="scope.row.fromType == 'APP'">APP</div>
            <div v-if="scope.row.fromType == 'miniApp'">网校小程序</div>
            <div v-if="scope.row.fromType == 'miniApp3'">弘智课堂小程序</div>
            <div v-if="scope.row.fromType == 'weixin'">微信H5</div>
            <div v-if="scope.row.fromType == 'hzy'">弘智云</div>
            <div v-if="scope.row.fromType == 'miniApp4'">弘智助手小程序</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="lastLoginTime"
          label="最近一次登录"
          width="180px"
        ></el-table-column>
        <el-table-column
          prop="questionCount"
          label="累计做题"
          width="100px"
        ></el-table-column>
        <el-table-column
          prop="questionAccuracyRate"
          label="正确率"
          width="80px"
        ></el-table-column>
        <el-table-column
          prop="questionCompletionRate"
          label="题库完成率"
          width="80px"
        ></el-table-column>
        <el-table-column
          prop="videoDuration"
          label="累计观看时长"
          width="100px"
        ></el-table-column>
        <el-table-column
          prop="videoCompletionRate"
          label="视频完成率"
          width="100px"
        ></el-table-column>
        <el-table-column
          prop="questionAnsweringCount"
          label="问题答疑"
          width="100px"
        ></el-table-column>
        <el-table-column
          prop="solvedQuestionAnsweringCount"
          label="已回复"
          width="80px"
        ></el-table-column>
        <el-table-column
          prop="card"
          label="身份证"
          width="180px"
        ></el-table-column>
        <el-table-column
          prop="campusName"
          label="校区"
          width="180px"
        ></el-table-column>

        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="row">
            <span
              class="courseManage style1"
              v-if="row.row.learningState == '在读'"
              >{{ row.row.learningState }}</span
            >
            <span
              class="courseManage style3"
              v-if="row.row.learningState == '未读'"
              >{{ row.row.learningState }}</span
            >
            <span
              class="courseManage style2"
              v-if="row.row.learningState == '毕业'"
              >{{ row.row.learningState }}</span
            >
          </template>
        </el-table-column>
        <!-- <el-table-column prop="createTime" label="注册时间"></el-table-column> -->
        <!-- <el-table-column prop="registerIp" label="报名课程(已上/总课时)" width="200"></el-table-column>
        <el-table-column prop="registerIp" label="班级"></el-table-column>-->
        <el-table-column
          prop
          label="操作"
          width="200"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <div class="operationGroup">
              <span
                v-auth="'student_/student/getStudent/'"
                class="mainColor"
                @click=";(selection = scope.row.id), (viewFormVisible = true)"
                >查看</span
              >
              <span
                v-auth="'student_/student/updateStudent'"
                class="mainColor"
                @click="
                  ;(selection = scope.row.id),
                    (editFormVisible = true),
                    getRegionTree(),
                    getCampusList()
                "
                >编辑</span
              >
              <!-- <span class="mainColor" @click="goOpen(scope.row)">开课</span>
              <span class="mainColor" @click="getPageList(scope.row.id)">开课记录</span>-->
              <span
                class="mainColor"
                v-auth="'student_/student/resetStudentPassword'"
                @click="resetStudentPassword(scope.row)"
                >重置密码</span
              >
              <span class="mainColor" @click="seeOverviewDetails(scope.row)"
                >学习详情</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-auth="'student_/student/classInfoPageList'"
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px; text-align: right"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="添加学员" :visible.sync="addFormVisible" width="50%" left>
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="addFormRules"
      >
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="校区">
              <el-cascader
                style="width: 100%"
                clearable
                v-model="addForm.campusId"
                :show-all-levels="false"
                :props="campusTreeProps"
                placeholder="请选择所属校区"
                :options="campusList"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="学生姓名" prop="name">
              <el-input
                v-model="addForm.name"
                placeholder="请输入学生姓名"
                auto-complete="new-name"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="手机号码" prop="mobile">
              <el-input
                v-model="addForm.mobile"
                placeholder="请输入手机号码"
                auto-complete="off"
                maxlength="11"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="addForm.email"
                placeholder="请输入邮箱"
                auto-complete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="addForm.sex">
                <el-radio label>未知</el-radio>
                <el-radio :label="1">男</el-radio>
                <el-radio :label="-1">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <!-- <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="密码" prop="password">
              <el-input
                type="password"
                v-model="addForm.password"
                placeholder="请输入密码"
                auto-complete="new-password"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>-->
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="身份证">
              <el-input
                v-model="addForm.card"
                placeholder="请输入身份证"
                auto-complete="off"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="联系地址" prop="address">
              <el-input
                v-model="addForm.address"
                placeholder="请输入联系地址"
                auto-complete="off"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="addForm.sex">
                <el-radio label>未知</el-radio>
                <el-radio :label="1">男</el-radio>
                <el-radio :label="-1">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>-->
        <el-row :span="24"></el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                type="textarea"
                :rows="3"
                v-model="addForm.remark"
                placeholder="请输入备注"
                auto-complete="off"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="height: 40px">
        <div slot="footer" class="dialog-footer" style="float: left">
          <el-button
            @click=";(importFormVisible = true), (addFormVisible = false)"
            >批量导入</el-button
          >
        </div>
        <div slot="footer" class="dialog-footer" style="float: right">
          <el-button @click="addFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="addStudent">确 定</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑学员"
      :visible.sync="editFormVisible"
      width="50%"
      left
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="校区">
              <el-cascader
                style="width: 100%"
                clearable
                v-model="editForm.campusId"
                :show-all-levels="false"
                :props="campusTreeProps"
                placeholder="请选择所属校区"
                :options="campusList"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="学生姓名" prop="name">
              <el-input
                v-model="editForm.name"
                placeholder="请输入学生姓名"
                auto-complete="new-name"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="手机号码" prop="mobile">
              <el-input
                v-model="editForm.mobile"
                placeholder="请输入手机号码"
                auto-complete="off"
                maxlength="11"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="editForm.email"
                placeholder="请输入邮箱"
                auto-complete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="editForm.sex">
                <el-radio label>未知</el-radio>
                <el-radio :label="1">男</el-radio>
                <el-radio :label="-1">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <!-- <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="密码" prop="password">
              <el-input
                type="password"
                v-model="addForm.password"
                placeholder="请输入密码"
                auto-complete="new-password"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>-->
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="身份证">
              <el-input
                v-model="editForm.card"
                placeholder="请输入身份证"
                auto-complete="off"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="联系地址" prop="address">
              <el-input
                v-model="editForm.address"
                placeholder="请输入联系地址"
                auto-complete="off"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="addForm.sex">
                <el-radio label>未知</el-radio>
                <el-radio :label="1">男</el-radio>
                <el-radio :label="-1">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>-->
        <el-row :span="24"></el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                type="textarea"
                :rows="3"
                v-model="editForm.remark"
                placeholder="请输入备注"
                auto-complete="off"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateStudent">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="查看学员信息"
      class="viewForm"
      :visible.sync="viewFormVisible"
      width="50%"
      left
    >
      <el-form
        :model="studentDetail"
        ref="studentDetail"
        :label-width="formLabelWidth"
      >
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="姓名：" prop="name">
              <span>{{ studentDetail.name }}</span>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="校区：" prop="name">
              <span>{{ studentDetail.campusName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="报名课程：" prop="name">
              <span
                style="margin-right: 10px; display: flex; height: 25px"
                v-for="(item, index) in studentDetail.goodsInfos"
                :key="index"
                >{{ item.name }}</span
              >
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="班级：" prop="name">
              <span
                style="margin-right: 10px; display: flex; height: 25px"
                v-for="(item, index) in studentDetail.historyCourseList"
                :key="index"
                >{{ item.name }}</span
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="手机：" prop="mobile">
              <span>{{ studentDetail.mobile }}</span>
            </el-form-item>
          </el-col>

          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="邮箱：" prop="email">
              <span>{{ studentDetail.email }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="性别：" prop="sex">
              <span>{{
                studentDetail.sex == ''
                  ? '未知'
                  : studentDetail.sex == 1
                  ? '男'
                  : '女'
              }}</span>
            </el-form-item>
          </el-col>

          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="来源：" prop="card">
              <span>{{ studentDetail.fromType }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="身份证：" prop="card">
              <span>{{ studentDetail.card }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="24">
            <el-form-item label="联系地址：" prop="address">
              <span>{{ studentDetail.address }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="24">
            <el-form-item label="备注：" prop="remark">
              <span>{{ studentDetail.remark }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog
      title="导入学员"
      :visible.sync="importFormVisible"
      width="800px"
      left
    >
      <el-row style="margin-bottom: 10px" class="importForm">
        <el-col :span="4">
          <el-upload
            class="upload-demo"
            :action="fileAction"
            :on-success="handleSuccess"
            :headers="reqData"
            :file-list="fileList"
          >
            <el-button>上传附件</el-button>
          </el-upload>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="importExcel">下载模板</el-button>
        </el-col>
        <el-col :span="16" style="text-align: right">
          <el-button type="primary" @click="importData" icon="el-icon-document"
            >导入数据</el-button
          >
        </el-col>
      </el-row>
      <!-- <div>只能上传xls、xlsx文件，且不超过1024kb</div> -->
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 22px; width: 100%"
        border
        @selection-change="selectionChange"
      >
        <el-table-column
          type="selection"
          :selectable="checkboxT"
          width="55"
        ></el-table-column>
        <el-table-column prop="name" label="学员姓名"></el-table-column>
        <el-table-column prop="card" label="身份证"></el-table-column>
        <el-table-column prop="mobile" label="学员手机"></el-table-column>
        <el-table-column prop="remark" label="备注">
          <template slot-scope="scope">
            <span style="color: red">{{ scope.row.remark }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button type="primary" @click="importData" icon="el-icon-document">导入数据</el-button>
      </div>-->
    </el-dialog>
    <el-dialog
      title="开课记录"
      :visible.sync="subjectListVisible"
      width="60%"
      left
    >
      <el-table
        ref="multipleTable"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        :data="subjectList"
        tooltip-effect="dark"
        style="width: 100%"
        border
      >
        <el-table-column prop="name" show-overflow-tooltip label="商品">
          <template slot-scope="row">
            <el-row>
              <el-col :span="8">
                <span>
                  <img
                    style="margin-right: 10px"
                    width="100%"
                    height="auto"
                    :src="row.row.img"
                  />
                </span>
              </el-col>
              <el-col :span="16">
                <span
                  style="color: rgb(36, 210, 181); margin-left: 10px"
                  v-if="row.row.recommend == '1'"
                  >{{ '[推荐]' }}</span
                >
                <span
                  style="color: rgb(36, 210, 181); margin-left: 10px"
                  v-if="row.row.hot == '1'"
                  >{{ '[热门]' }}</span
                >
                <span style="color: rgb(77, 148, 255); margin-left: 10px">{{
                  row.row.name
                }}</span>
                <span style="display: block; margin-left: 10px">
                  <span style="color: red">￥{{ row.row.price }}</span>
                  <span
                    style="
                      text-decoration: line-through;
                      color: rgb(162, 170, 188);
                    "
                    >￥{{ row.row.originalPrice }}</span
                  >
                </span>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="100"
          prop="agentPrice"
          label="开通价"
        >
          <template slot-scope="row">
            <span style="color: red; font-weight: bold">{{
              row.row.agentPrice
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="validDay"
          width="100"
          label="有效期"
        >
          <template slot-scope="row">{{ row.row.validDay }}天</template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="200"
          prop="subjectCourseName"
          label="所属科目"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="60"
          prop="goodsItemCount"
          label="内容"
        ></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button
          type="primary"
          @click="subjectListVisible = false"
          icon="el-icon-document"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import md5 from "md5";

export default {
  data () {
    return {
      // 身份
      roleName: "",
      groupList: [],
      subjectList: [],
      campusList: [],
      subjectListVisible: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      viewFormVisible: false,
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      options: [],
      region: [],
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      searchForm: {
        studentGroupIds: [],
        name: "",
        account: "",
        fromType: "",
        createTime: "",
        showAllTate: "1",
      },
      regionTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      addForm: {
        name: "",
        studentGroupId: "",
        account: "",
        sex: 1,
        card: null,
        email: "",
        address: "",
        remark: "",
      },
      addFormRules: {
        email: [
          {
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "邮箱号码格式不正确",
          },
        ],
        card: [
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "身份证号码格式不正确",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
          {
            min: 1,
            max: 11,
            message: "手机号码长度在1到11个字",
          },
          {
            pattern: /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/,
            message: "手机号码格式不正确",
          },
        ],
        studentGroupId: [
          {
            required: true,
            message: "请选择学员分组",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入学生姓名",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "学生姓名长度在1到255个字",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "密码长度在1到255个字",
          },
        ],
      },
      editForm: {
        account: "",
        name: "",
        sex: "",
        card: "",
        email: "",
        address: "",
        remark: "",
      },
      studentDetail: {},
      editFormRules: {
        email: [
          {
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "邮箱号码格式不正确",
          },
        ],
        studentGroupId: [
          {
            required: true,
            message: "请选择学员分组",
            trigger: "blur",
          },
        ],
        card: [
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "身份证号码格式不正确",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
          {
            min: 1,
            max: 11,
            message: "手机号码长度在1到11个字",
          },
          {
            pattern: /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/,
            message: "手机号码格式不正确",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入学生姓名",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "学生姓名长度在1到255个字",
          },
        ],

        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "密码长度在1到255个字",
          },
        ],
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      regionList: [],
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/student/upload`,
      fileList: [],
      studentGroupLIst: [],
      loading: false,
      exportLoading: false,
    };
  },
  created() {
    this.roleName = JSON.parse(localStorage.getItem("user")).roleName;
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData () {
      return this.$store.state.user;
    },
  },
  methods: {
    campusChange (val) {
      this.searchForm.campusId = val[2];
    },
    // 是否启用
    updateSwitching (row) {
      console.log(row, 99999999);
      var para={
        "id": row.id, //学员id
        "state": row.state//是否启用：是1否-1
      }
      this.api.student
        .studentOnOrOff(para)
        .then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.pageList();
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    seeOverviewDetails (obj) {
      this.$router.push(`/studentGoodsContent?id=${obj.id}`);
    },
    importExcel () {
      window.open(
        // "https://68wx--test.oss-cn-hangzhou.aliyuncs.com/student/%E5%AD%A6%E7%94%9F%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xls"
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/materials/16190125872036.xls"
      );
    },
    addRegionChange () {
      this.addForm.regionId = this.region[1];
    },
    editRegionChange () {
      this.editForm.regionId = this.region[1];
    },
    getPageList (id) {
      this.api.goodsInfo
        .getStudentBuyGoodsList({ id: id })
        .then((result) => {
          if (result.data) {
            this.subjectList = result.data;
          } else {
            this.subjectList = [];
          }
          this.subjectListVisible = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },

    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      console.log("val", val);
      this.multipleSelection = val;
      val.map((e) => this.ids.push({ id: e.id }));
      console.log("this.ids", this.ids);
    },
    getStudent () {
      this.api.student
        .getStudent({
          id: this.selection,
        })
        .then((result) => {
          this.editForm = result.data;
          this.region = this.editForm.regionId;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getStudentDetail () {
      this.api.student
        .getStudentDetail({
          id: this.selection,
        })
        .then((result) => {
          this.studentDetail = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageList () {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.agentId = this.loginData.agentId;
      this.api.student
        .classInfoPageList(this.searchForm)
        .then((result) => {
          this.loading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addStudent () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          if (this.addForm.campusId) {
            this.addForm.campusId = this.addForm.campusId[2];
          }
          this.addForm.agentId = this.loginData.agentId;
          this.api.student
            .addStudent(this.addForm)
            .then((result) => {
              if (result.success) {
                this.$message.success(result.message);
                this.addFormVisible = false;
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateStudent () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          // console.log(typeof this.editForm.campusId);
          if (typeof this.editForm.campusId == "object") {
            let index = this.editForm.campusId.length;
            this.editForm.campusId = this.editForm.campusId[index - 1];
          }
          this.editForm.agentId = this.loginData.agentId;
          this.api.student
            .updateStudent(this.editForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteStudent (row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.student
            .deleteStudent([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    batchDeleteStudent () {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.student
            .deleteStudent(this.ids)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    reset () {
      this.searchForm.studentGroupIds = [];
      this.$refs.searchForm.resetFields();
      this.page.pageSize = 10;
      this.page.pageNumber = 1;
      this.page.sortName = "";
      this.page.sortOrder = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },
    handleSuccess (response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel () {
      this.exportLoading = true;
      setTimeout(() => {
        this.exportLoading = false;
      }, 5000);
      let obj = Object.assign({}, this.searchForm);
      delete obj.createTime;
      this.api.student
        .exportExcel(obj)
        .then((result) => {
          if (result.code == 200) {
            let url = result.data;

            this.$message.success(url);

            this.exportLoading = false;
            this.$message.success(result.data);
          } else {
            this.exportLoading = false;
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          this.exportLoading = false;
          console.log(error);
        });
    },
    resetStudentPassword (row) {
      this.$confirm("您确定要重置密码吗？", "系统消息", {
        type: "warning",
      }).then(() => {
        this.api.student
          .resetStudentPassword({ id: row.id })
          .then((result) => {
            if (result.success) {
              this.$message.success("操作成功，密码为您的手机号！");
            } else {
              this.$message.error(result.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    goOpen (row) {
      this.$router.push({
        path: "/open",
        query: {
          phone: row ? row.account : "",
          id: row ? row.id : "",
        },
      });
    },
    importData () {
      if (this.multipleSelection.length == 0) {
        this.$message("请选择需要导入的学员");
      } else {
        this.api.student
          .importData(this.multipleSelection)
          .then((result) => {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.multipleSelection = [];
            this.pageList();
            this.importFormVisible = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getCampusList () {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getRegionTree () {
      this.api.getRegionTree().then((result) => {
        if (result.success) {
          this.regionList = result.data;
        }
      });
    },
    getStudentGroupList () {
      this.api.student
        .getStudentGroupList({})
        .then((result) => {
          this.groupList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.api.student
        .getStudentFromTypeList({})
        .then((result) => {
          this.options = result.data;
        })
        .catch((error) => {
          console.log(error);
        });

      this.api.student
        .getStudentGroupList({})
        .then((result) => {
          this.studentGroupLIst = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkboxT (row, rowIndex) {
      if (row.remark == "") {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    "searchForm.createTime": function (newVal) {
      if (newVal) {
        this.searchForm.beginDate = newVal[0];
        this.searchForm.endDate = newVal[1];
      } else {
        this.searchForm.createTime = [];
        this.searchForm.beginDate = "";
        this.searchForm.endDate = "";
      }
    },
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getStudent();
      }
    },
    importFormVisible: function (newVal) {
      if (!newVal) {
        this.importForm = {};
      } else {
      }
    },
    viewFormVisible: function (newVal) {
      if (!newVal) {
        this.studentDetail = {};
        this.$refs.studentDetail.resetFields();
      } else {
        this.getStudentDetail();
      }
    },
  },
  mounted () {
    this.pageList();
    this.getStudentGroupList();
    this.getCampusList();
  },
};
</script>
<style scoped>
.answer {
  width: 130px;
  white-space: nowrap;
  overflow: hidden;
  color: #409eff;
  text-overflow: ellipsis;
}
.courseManage {
  padding: 3px 14px 3px 14px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
}
.style1 {
  background: rgb(36, 210, 181);
  border: solid 1px rgb(36, 210, 181);
}
.style2 {
  background: rgb(255, 185, 28);
  border: solid 1px rgb(255, 185, 28);
}
.style3 {
  background: rgb(162, 170, 188);
  border: solid 1px rgb(162, 170, 188);
}
</style>
<style lang="less">
.student {
  .el-select {
    width: 100% !important;
  }
  .viewForm {
    .el-dialog__body {
      padding-top: 0px;
    }
    .el-form-item {
      margin-bottom: 0px !important;
    }
  }
  .importForm {
    .el-upload-list {
      display: none !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/student/student.vue